export var HapticFeedbackTypes;
(function (HapticFeedbackTypes) {
    HapticFeedbackTypes["selection"] = "selection";
    HapticFeedbackTypes["impactLight"] = "impactLight";
    HapticFeedbackTypes["impactMedium"] = "impactMedium";
    HapticFeedbackTypes["impactHeavy"] = "impactHeavy";
    HapticFeedbackTypes["rigid"] = "rigid";
    HapticFeedbackTypes["soft"] = "soft";
    HapticFeedbackTypes["notificationSuccess"] = "notificationSuccess";
    HapticFeedbackTypes["notificationWarning"] = "notificationWarning";
    HapticFeedbackTypes["notificationError"] = "notificationError";
    HapticFeedbackTypes["clockTick"] = "clockTick";
    HapticFeedbackTypes["contextClick"] = "contextClick";
    HapticFeedbackTypes["keyboardPress"] = "keyboardPress";
    HapticFeedbackTypes["keyboardRelease"] = "keyboardRelease";
    HapticFeedbackTypes["keyboardTap"] = "keyboardTap";
    HapticFeedbackTypes["longPress"] = "longPress";
    HapticFeedbackTypes["textHandleMove"] = "textHandleMove";
    HapticFeedbackTypes["virtualKey"] = "virtualKey";
    HapticFeedbackTypes["virtualKeyRelease"] = "virtualKeyRelease";
    HapticFeedbackTypes["effectClick"] = "effectClick";
    HapticFeedbackTypes["effectDoubleClick"] = "effectDoubleClick";
    HapticFeedbackTypes["effectHeavyClick"] = "effectHeavyClick";
    HapticFeedbackTypes["effectTick"] = "effectTick";
})(HapticFeedbackTypes || (HapticFeedbackTypes = {}));
//# sourceMappingURL=types.js.map